module.exports = {
  1: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  31: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  41: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  56: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  97: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  137: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  8453: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  17000: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  42161: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  43113: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  43114: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  59140: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  59144: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  80001: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  84532: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  421614: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  11155111: '0xe30E9c001dEFb5F0B04fD21662454A2427F4257A',
  245022926: '0x73F9D153B290bd8c9E3ab4BC60eA1d296b80A1B1',
  245022934: '0x4fd6C583BEbF113b692d0E42f8e040a229ba0866',
}
